import { CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetGroups =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.groups.get;
      const response = await PostFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageGroups =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      var body = {};
      console.log({ valuesvaluesvaluesvalues: values });
      if (editMode) {
        body.id = values?.id;
      }
      if (CheckDataIfExit(values?.group_name)) {
        body.group_name = values?.group_name?.trim();
      }
      if (CheckDataIfExit(values?.nationality_id)) {
        body.nationality_id = values?.nationality_id;
      }
      if (CheckDataIfExit(values?.visa_type)) {
        body.type_id = values?.visa_type;
      }
      const response = await PostFunction({
        data: body,
        Route: editMode ? UrlApi.groups.edit : UrlApi.groups.add,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditGroups =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          id: id,
          [nameFailed]: dataFailed,
        };
      }
      const response = await PostFunction({
        data,
        Route: UrlApi.groups.edit,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const DeleteGroups =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data = {
        idgroups: id,
      };
      const response = await PostFunction({
        data,
        Route: UrlApi.groups.delete,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
